import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { setSearchStore } from '../helpers/routeHelpers';
import { rootReducer } from '../modules';

const configureStore = (initialState, options) => {
  const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(thunk)));
  setSearchStore(store);
  return store;
};

export default configureStore;
